<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  components: {
    Chart,
  },
  data() {
    return {
      cdata: {
        nods: [
          {
            value: [500, 1300],
            nodeName: '主仓',
            symbol:
              'path://M508.368794 0l232.397163 137.985816v275.971631L508.368794 544.680851 275.971631 406.695035V137.985816L508.368794 0zM232.397163 472.056738l232.397163 137.985815v275.971631L232.397163 1016.737589 0 878.751773V610.042553l232.397163-137.985815zM1016.737589 610.042553l-232.397163-137.985815-239.659575 137.985815v275.971631l232.397163 137.985816 232.397163-137.985816V610.042553z',
            symbolSize: 40,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [100, 600],
            nodeName: '分仓1',
            symbol:
              'path://M512 65c246.871 0 447 200.129 447 447S758.871 959 512 959 65 758.871 65 512 265.129 65 512 65z m0 64c-211.525 0-383 171.475-383 383s171.475 383 383 383 383-171.475 383-383-171.475-383-383-383z m220 538.5c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32h440zM312.933 468c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m132 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m-187.73-243.975l220 82.222A32 32 0 0 1 764 336.222V394c0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32v-57.778a32 32 0 0 1 20.797-29.975l220-82.222a32 32 0 0 1 22.406 0zM512 288.161l-188 70.263V362h376v-3.576l-188-70.263z',
            symbolSize: 35,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [500, 600],
            nodeName: '分仓2',
            symbol:
              'path://M512 65c246.871 0 447 200.129 447 447S758.871 959 512 959 65 758.871 65 512 265.129 65 512 65z m0 64c-211.525 0-383 171.475-383 383s171.475 383 383 383 383-171.475 383-383-171.475-383-383-383z m220 538.5c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32h440zM312.933 468c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m132 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m-187.73-243.975l220 82.222A32 32 0 0 1 764 336.222V394c0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32v-57.778a32 32 0 0 1 20.797-29.975l220-82.222a32 32 0 0 1 22.406 0zM512 288.161l-188 70.263V362h376v-3.576l-188-70.263z',
            symbolSize: 35,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [900, 600],
            nodeName: '分仓3',
            symbol:
              'path://M512 65c246.871 0 447 200.129 447 447S758.871 959 512 959 65 758.871 65 512 265.129 65 512 65z m0 64c-211.525 0-383 171.475-383 383s171.475 383 383 383 383-171.475 383-383-171.475-383-383-383z m220 538.5c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32h440zM312.933 468c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m132 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m133 0c17.673 0 32 14.327 32 32v92c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32v-92c0-17.673 14.327-32 32-32z m-187.73-243.975l220 82.222A32 32 0 0 1 764 336.222V394c0 17.673-14.327 32-32 32H292c-17.673 0-32-14.327-32-32v-57.778a32 32 0 0 1 20.797-29.975l220-82.222a32 32 0 0 1 22.406 0zM512 288.161l-188 70.263V362h376v-3.576l-188-70.263z',
            symbolSize: 35,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [0, 300],
            nodeName: '副仓1',
            symbol:
              'path://M96 646.4v-384c0-19.2 19.2-38.4 38.4-38.4h384c19.2 0 38.4 19.2 38.4 38.4v384c0 6.4-6.4 12.8-12.8 12.8H108.8c-6.4 0-12.8-6.4-12.8-12.8z m307.2 128c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S288 755.2 288 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4zM256 697.6H76.8c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h140.8c6.4-25.6 19.2-51.2 38.4-64z m563.2 76.8c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S704 755.2 704 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4z m179.2-64v38.4c0 6.4-6.4 12.8-12.8 12.8H844.8c-6.4-51.2-51.2-89.6-102.4-89.6s-96 38.4-102.4 89.6H428.8c-6.4-25.6-19.2-51.2-38.4-64h198.4V332.8c0-12.8 12.8-25.6 25.6-25.6H736c32 0 64 19.2 83.2 44.8L896 467.2c12.8 19.2 19.2 38.4 19.2 57.6v172.8h32c6.4 0 12.8 0 12.8 12.8zM832 467.2l-64-89.6c0-6.4-6.4-6.4-12.8-6.4h-96c-6.4 0-12.8 6.4-12.8 12.8v89.6c0 6.4 6.4 12.8 12.8 12.8h160c12.8 0 19.2-12.8 12.8-19.2z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },

          {
            value: [200, 300],
            nodeName: '副仓2',
            symbol:
              'path://M96 646.4v-384c0-19.2 19.2-38.4 38.4-38.4h384c19.2 0 38.4 19.2 38.4 38.4v384c0 6.4-6.4 12.8-12.8 12.8H108.8c-6.4 0-12.8-6.4-12.8-12.8z m307.2 128c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S288 755.2 288 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4zM256 697.6H76.8c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h140.8c6.4-25.6 19.2-51.2 38.4-64z m563.2 76.8c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S704 755.2 704 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4z m179.2-64v38.4c0 6.4-6.4 12.8-12.8 12.8H844.8c-6.4-51.2-51.2-89.6-102.4-89.6s-96 38.4-102.4 89.6H428.8c-6.4-25.6-19.2-51.2-38.4-64h198.4V332.8c0-12.8 12.8-25.6 25.6-25.6H736c32 0 64 19.2 83.2 44.8L896 467.2c12.8 19.2 19.2 38.4 19.2 57.6v172.8h32c6.4 0 12.8 0 12.8 12.8zM832 467.2l-64-89.6c0-6.4-6.4-6.4-12.8-6.4h-96c-6.4 0-12.8 6.4-12.8 12.8v89.6c0 6.4 6.4 12.8 12.8 12.8h160c12.8 0 19.2-12.8 12.8-19.2z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [500, 100],
            nodeName: '副仓3',
            symbol:
              'path://M96 646.4v-384c0-19.2 19.2-38.4 38.4-38.4h384c19.2 0 38.4 19.2 38.4 38.4v384c0 6.4-6.4 12.8-12.8 12.8H108.8c-6.4 0-12.8-6.4-12.8-12.8z m307.2 128c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S288 755.2 288 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4zM256 697.6H76.8c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h140.8c6.4-25.6 19.2-51.2 38.4-64z m563.2 76.8c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S704 755.2 704 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4z m179.2-64v38.4c0 6.4-6.4 12.8-12.8 12.8H844.8c-6.4-51.2-51.2-89.6-102.4-89.6s-96 38.4-102.4 89.6H428.8c-6.4-25.6-19.2-51.2-38.4-64h198.4V332.8c0-12.8 12.8-25.6 25.6-25.6H736c32 0 64 19.2 83.2 44.8L896 467.2c12.8 19.2 19.2 38.4 19.2 57.6v172.8h32c6.4 0 12.8 0 12.8 12.8zM832 467.2l-64-89.6c0-6.4-6.4-6.4-12.8-6.4h-96c-6.4 0-12.8 6.4-12.8 12.8v89.6c0 6.4 6.4 12.8 12.8 12.8h160c12.8 0 19.2-12.8 12.8-19.2z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [700, 300],
            nodeName: '副仓4',
            symbol:
              'path://M96 646.4v-384c0-19.2 19.2-38.4 38.4-38.4h384c19.2 0 38.4 19.2 38.4 38.4v384c0 6.4-6.4 12.8-12.8 12.8H108.8c-6.4 0-12.8-6.4-12.8-12.8z m307.2 128c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S288 755.2 288 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4zM256 697.6H76.8c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h140.8c6.4-25.6 19.2-51.2 38.4-64z m563.2 76.8c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S704 755.2 704 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4z m179.2-64v38.4c0 6.4-6.4 12.8-12.8 12.8H844.8c-6.4-51.2-51.2-89.6-102.4-89.6s-96 38.4-102.4 89.6H428.8c-6.4-25.6-19.2-51.2-38.4-64h198.4V332.8c0-12.8 12.8-25.6 25.6-25.6H736c32 0 64 19.2 83.2 44.8L896 467.2c12.8 19.2 19.2 38.4 19.2 57.6v172.8h32c6.4 0 12.8 0 12.8 12.8zM832 467.2l-64-89.6c0-6.4-6.4-6.4-12.8-6.4h-96c-6.4 0-12.8 6.4-12.8 12.8v89.6c0 6.4 6.4 12.8 12.8 12.8h160c12.8 0 19.2-12.8 12.8-19.2z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [1000, 300],
            nodeName: '副仓5',
            symbol:
              'path://M96 646.4v-384c0-19.2 19.2-38.4 38.4-38.4h384c19.2 0 38.4 19.2 38.4 38.4v384c0 6.4-6.4 12.8-12.8 12.8H108.8c-6.4 0-12.8-6.4-12.8-12.8z m307.2 128c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S288 755.2 288 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4zM256 697.6H76.8c-6.4 0-12.8 6.4-12.8 12.8v38.4c0 6.4 6.4 12.8 12.8 12.8h140.8c6.4-25.6 19.2-51.2 38.4-64z m563.2 76.8c0 44.8-38.4 76.8-76.8 76.8-44.8 0-76.8-38.4-76.8-76.8s38.4-76.8 76.8-76.8c44.8 0 76.8 32 76.8 76.8z m-38.4 0c0-19.2-19.2-38.4-38.4-38.4S704 755.2 704 774.4s19.2 38.4 38.4 38.4 38.4-19.2 38.4-38.4z m179.2-64v38.4c0 6.4-6.4 12.8-12.8 12.8H844.8c-6.4-51.2-51.2-89.6-102.4-89.6s-96 38.4-102.4 89.6H428.8c-6.4-25.6-19.2-51.2-38.4-64h198.4V332.8c0-12.8 12.8-25.6 25.6-25.6H736c32 0 64 19.2 83.2 44.8L896 467.2c12.8 19.2 19.2 38.4 19.2 57.6v172.8h32c6.4 0 12.8 0 12.8 12.8zM832 467.2l-64-89.6c0-6.4-6.4-6.4-12.8-6.4h-96c-6.4 0-12.8 6.4-12.8 12.8v89.6c0 6.4 6.4 12.8 12.8 12.8h160c12.8 0 19.2-12.8 12.8-19.2z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [850, 0],
            nodeName: '站点1',
            symbol:
              'path://M947.2 454.4L832 345.6V192h-166.4l-128-121.6c-19.2-6.4-32-6.4-44.8 0l-416 384c-12.8 12.8-19.2 32-6.4 44.8 12.8 12.8 32 12.8 44.8 0L512 140.8l396.8 364.8c6.4 6.4 12.8 6.4 19.2 6.4 6.4 0 19.2-6.4 25.6-12.8 12.8-12.8 6.4-32-6.4-44.8zM768 256v32l-38.4-32h38.4zM352 928c0 19.2-12.8 32-32 32-70.4 0-128-51.2-128-108.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32v275.2c0 19.2 32 44.8 64 44.8 19.2 0 32 12.8 32 32zM832 576v275.2c0 57.6-57.6 108.8-128 108.8-19.2 0-32-12.8-32-32s12.8-32 32-32c32 0 64-25.6 64-44.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32z m-448 128h256l-128 192-128-192z m256-192l-128 192-128-192h256z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [80, 0],
            nodeName: '站点2',
            symbol:
              'path://M947.2 454.4L832 345.6V192h-166.4l-128-121.6c-19.2-6.4-32-6.4-44.8 0l-416 384c-12.8 12.8-19.2 32-6.4 44.8 12.8 12.8 32 12.8 44.8 0L512 140.8l396.8 364.8c6.4 6.4 12.8 6.4 19.2 6.4 6.4 0 19.2-6.4 25.6-12.8 12.8-12.8 6.4-32-6.4-44.8zM768 256v32l-38.4-32h38.4zM352 928c0 19.2-12.8 32-32 32-70.4 0-128-51.2-128-108.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32v275.2c0 19.2 32 44.8 64 44.8 19.2 0 32 12.8 32 32zM832 576v275.2c0 57.6-57.6 108.8-128 108.8-19.2 0-32-12.8-32-32s12.8-32 32-32c32 0 64-25.6 64-44.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32z m-448 128h256l-128 192-128-192z m256-192l-128 192-128-192h256z',
            symbolSize: 25,
            itemStyle: {
              color: 'orange',
            },
          },
          {
            value: [320, 0],
            nodeName: '站点3',
            symbol:
              'path://M947.2 454.4L832 345.6V192h-166.4l-128-121.6c-19.2-6.4-32-6.4-44.8 0l-416 384c-12.8 12.8-19.2 32-6.4 44.8 12.8 12.8 32 12.8 44.8 0L512 140.8l396.8 364.8c6.4 6.4 12.8 6.4 19.2 6.4 6.4 0 19.2-6.4 25.6-12.8 12.8-12.8 6.4-32-6.4-44.8zM768 256v32l-38.4-32h38.4zM352 928c0 19.2-12.8 32-32 32-70.4 0-128-51.2-128-108.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32v275.2c0 19.2 32 44.8 64 44.8 19.2 0 32 12.8 32 32zM832 576v275.2c0 57.6-57.6 108.8-128 108.8-19.2 0-32-12.8-32-32s12.8-32 32-32c32 0 64-25.6 64-44.8V576c0-19.2 12.8-32 32-32s32 12.8 32 32z m-448 128h256l-128 192-128-192z m256-192l-128 192-128-192h256z',
            symbolSize: 20,
            itemStyle: {
              color: 'orange',
            },
          },
        ],
        linesData: [
          {
            coords: [
              [500, 1000],
              [500, 800],
            ],
          },
          {
            coords: [
              [500, 800],
              [100, 800],
              [100, 600],
            ],
          },
          {
            coords: [
              [500, 800],
              [500, 600],
            ],
          },
          {
            coords: [
              [500, 800],
              [900, 800],
              [900, 600],
            ],
          },
          {
            coords: [
              [100, 600],
              [0, 300],
            ],
          },
          {
            coords: [
              [500, 400],

              [500, 100],
            ],
          },
          {
            coords: [
              [100, 600],
              [200, 300],
            ],
          },
          {
            coords: [
              [500, 600],
              [200, 300],
            ],
          },
          {
            coords: [
              [900, 600],
              [700, 300],
            ],
          },
          {
            coords: [
              [500, 600],
              [700, 300],
            ],
          },
          {
            coords: [
              [900, 600],
              [1000, 300],
            ],
          },
          {
            coords: [
              [0, 300],
              [75, 0],
            ],
          },
          {
            coords: [
              [200, 300],

              [75, 0],
            ],
          },
          {
            coords: [
              [200, 300],
              [320, 0],
            ],
          },
          {
            coords: [
              [500, 100],
              [320, 0],
            ],
          },
          {
            coords: [
              [700, 300],
              [820, 0],
            ],
          },
          {
            coords: [
              [1000, 300],
              [880, 0],
            ],
          },
        ],
      },
    }
  },
  created() {},
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="scss"></style>
